/**
 * Trova nella lista chat quella che corrisponde a un bersaglio arrivato da
 * fuori del drawer: un numero (solo cifre) o un JID completo (gruppo, @lid).
 * Modulo puro: lo usa il drawer, lo coprono i test in node.
 */
import { normalizeChatId as senzaSuffisso } from '../../utils/whatsappHelpers';

/** Senza suffisso e senza il "+" che qualche riga Cloud porta davanti. */
const normalizeChatId = (id: string) => senzaSuffisso(id).replace(/^\+/, '');

const NUMERO = /^\d{8,15}$/;

/** Un bersaglio per cui ha senso creare una conversazione nuova: un numero vero. */
export function isPlaceholderTarget(target: string): boolean {
  return NUMERO.test(target);
}

/**
 * - JID completo: uguaglianza (anche a meno del suffisso).
 * - Numero: prima l'uguaglianza esatta, poi il confronto per suffisso ma solo
 *   fra chat individuali con numero di almeno 8 cifre (niente gruppi, niente
 *   @lid, niente numeri corti che agganciano la chat sbagliata).
 */
export function trovaChatPerNumero<T extends { id: string; isGroup?: boolean }>(
  chats: readonly T[],
  target: string
): T | null {
  if (!target) return null;
  if (target.includes('@')) {
    const n = normalizeChatId(target);
    return chats.find((c) => c.id === target || normalizeChatId(c.id) === n) ?? null;
  }
  const esatta = chats.find((c) => !c.isGroup && normalizeChatId(c.id) === target);
  if (esatta) return esatta;
  if (!NUMERO.test(target)) return null;
  return (
    chats.find((c) => {
      if (c.isGroup || /@(lid|g\.us)$/.test(c.id)) return false;
      const d = normalizeChatId(c.id);
      if (!NUMERO.test(d)) return false;
      return d.endsWith(target) || target.endsWith(d);
    }) ?? null
  );
}
